module.exports = __webpack_public_path__ + "static/media/empty.1f09c74c.svg";